import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getJoinLink } from "../../backend/landing/joinLink";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const LandingBottomCard = ({ weekendId }: {weekendId:number}) => {
  const showCard = useMediaQuery({ query: `(min-width: 1024px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  return (
    <div style={{ ...styles.cardWrapper, flexDirection: isMobile ? "column" : "row" }}>
      <div
        style={{
          ...styles.cardContainer,
          margin: isMobile ? "3.5rem auto" : "5rem auto",
          marginLeft: isMobile ? "auto" : "var(--main-container-margin)",
        }}
      >
        {isMobile && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Button
              text={"МЕНІ ЦІКАВО!"}
              external_link={getJoinLink(weekendId)}
              textColor="var(--black)"
              hoverTextColor="var(--orange)"
              border="3px solid var(--black)"
              hoverBorder="3px solid var(--black)"
              backgroundColor="var(--orange)"
              hoverBackgroundColor="var(--black)"
              fontSize={isMobile ? "8vw" : "3.5rem"}
              padding="1rem 2rem"
              marginBottom={isMobile ? "3.5rem" : undefined}
              fontWeight="bold"
              containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
              isSimple={true}
            />
          </div>
        )}
        <p style={{ ...styles.mainHeading, fontSize: isMobile ? "10vw" : "clamp(3rem,4vw,5rem)" }}>
          {getWeekendInfoByName(weekendId,"bottomCardHeader")}
        </p>
        <p
          style={{
            ...styles.descriptionText,
            marginBottom: isMobile ? undefined : "3.5rem",
            fontSize: isMobile ? "7vw" : "clamp(2rem,2.3vw,2.7rem)",
            paddingRight:isMobile?"":"6rem",
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId,"bottomCardDescription")) }}
        ></p>
        {!isMobile && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Button
              text={"МЕНІ ЦІКАВО!"}
              external_link={getJoinLink(weekendId)}
              textColor="var(--black)"
              hoverTextColor="var(--orange)"
              border="3px solid var(--black)"
              hoverBorder="3px solid var(--black)"
              backgroundColor="var(--orange)"
              hoverBackgroundColor="var(--black)"
              fontSize={isMobile ? "8vw" : "3rem"}
              padding="1rem 2rem"
              marginBottom={isMobile ? "3rem" : undefined}
              fontWeight="bold"
              containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
              isSimple={true}
            />
          </div>
        )}
      </div>
      {isMobile && <img src={getWeekendInfoByName(weekendId,"bottomCardPhotoLinkMobile")} style={{ width: "100%" }}onError={(e) => e.currentTarget.src = "/assets/landing/photo2-mobile.jpg"} />}
      {showCard && (
        <div style={{ flex: 1 }}>
          <img
            src={getWeekendInfoByName(weekendId,"bottomCardPhotoLink")}
            style={{ width: "33vw", height: "100%", objectFit: "cover" }}
            onError={(e) => e.currentTarget.src = "/assets/landing/photo2.jpg"}
          />
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  cardWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--olive)",
    overflow: "visible",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
  },
  mainHeading: {
    color: "var(--dark-grey)",
    fontWeight: "bold",
    marginBottom: "3.5rem",
  },
  descriptionText: {
    color: "var(--dark-grey)",
  },
};

export default LandingBottomCard;
